import React, { useContext, useEffect, useState } from "react";
import InputDropdown from "../../CommonComponents/InputDropdown";
import InputField from "../../CommonComponents/InputField";
import Button from "../../Button";
import Modal from "../../CommonComponents/Modal";
import QuestionList from "./QuestionList";
import { LANG_ID, libTypeIds, RESULT_STATUS } from "../../../constants";
import Tooltip from "../../CommonComponents/Tooltip";
import ModalBody from "../../CommonComponents/ModalBody";
import QnCountField from "./QnCountField";
import AlertContext from "../../../context/AlertContext";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";

const LANGUAGES = Object.fromEntries(
  Object.entries(LANG_ID).map(([key, value]) => [value, key])
);

const ConfigureTopic = ({
  type = libTypeIds.MCQ,
  topic = {},
  difficulties = [],
  languages = [],
  descTypes = [],
  isVideoAssessment = false,
  onChange,
  index = 0,
  errors = {},
  setErrors,
  onDelete = null,
  topicError = [],
  isPublished = false,
  subjects = [],
  setTestDetails
}) => {
  const [showQuestionList, setShowQuestionList] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const { setIsLoaded, setShowNotify } = useContext(AlertContext);
  const axios = useAxiosPrivate();

  useEffect(() => {
    console.log("type:", type);
    (+type !== libTypeIds.MCQ || topic.subject) && getTopics();
  }, [topic.subject]);

  const getTopics = async () => {
    try {
      setIsLoaded(true);
      const { data } = await axios.get(
        `node/topic?type=${type}&isShared=true${topic?.subject && +type === libTypeIds.MCQ ? `&subjectId=${topic?.subject}` : ""}`,
      );
      if (data.resultCode === RESULT_STATUS.SUCCESS) {
        const formatedData = data?.data?.map((topic) => ({
          ...topic,
          value: topic.id,
          label: topic.name,
        }));
        console.log("index:", index);

        setTestDetails((prev) => ({
          ...prev,
          sections: prev.sections.map((sec) => {
            return {
              ...sec,
              topics: sec.topics.map((top) =>
                top.id === topic.id
                  ? { ...top, topics: formatedData }
                  : top
              )
            };
          })
        }));

      } else {
        setShowNotify({
          title: "Error !",
          msg:
            data?.msg ?? `Unable to get the topics. Please try again later`,
          show: true,
        });
      }
    } catch (error) {
      console.error("error in get topics", error);
      let isUnAuth = error.message.includes("403");
      setShowNotify({
        isUnAuth,
        title: isUnAuth ? "Warning !" : "Error !",
        msg: isUnAuth
          ? "You have been logged-out due to inactivity. Login again."
          : error.message ??
          `Unable to get the topics. Please try again later`,
        show: true,
      });
    } finally {
      setIsLoaded(false);
    }
  };

  const onConfigure = () => {
    if (!topic.topicId || !topic.complexityId) {
      setErrors((prev) => {
        let errors = structuredClone(prev);
        console.log("err...///", errors);
        if (!errors[1].topics[topic.id]) {
          errors[1].topics[topic.id] = {};
        }
        if (!topic.topicId)
          errors[1].topics[topic.id].topicId = "Select the topic";
        if (!topic.complexityId)
          errors[1].topics[topic.id].complexityId = "Select the difficulty";
        if (+type === libTypeIds.DESCRIPTIVE && !topic.configLibType) {
          errors[1].topics[topic.id].configLibType = "Select the type";
        }
        if (+type === libTypeIds.CODING_CHALLENGE && !topic.languages?.length)
          errors[1].topics[topic.id].languages = "Select the languages";
        return errors;
      });
      return;
    }
    if (!topic.fixedQnCount) {
      setErrors((prev) => {
        let errors = structuredClone(prev);
        errors[1].topics[topic.id].fixedQnCount = "Required";
        return errors;
      });
      return;
    }

    setShowQuestionList(true);
  };

  const hasErrors = errors?.topicId || errors?.complexityId;
  console.log("topicError", topicError);
  // console.log("topic:",configTopic,topic);

  return (
    <div
      className="test-config-section-detail-config-topic-questions"
      key={topic.id}
    >
      {index === 0 &&
        parseInt(type) !== libTypeIds.CODING_CHALLENGE &&
        parseInt(type) !== libTypeIds.SQL && <hr className="" />}
      <div className="test-config-section-detail-config-topic">
        <p className="test-config-section-detail-config-topic-title">
          Configure Topic{" "}
          {topicError?.length || errors?.invalidQnCount ? (
            <Tooltip
              title={
                errors?.invalidQnCount ? (
                  <p className="tooltip-config-topic-error">
                    {errors.invalidQnCount}
                  </p>
                ) : (
                  topicError.map((topErr) => (
                    topErr.id === topic.id &&
                    Object.entries(topErr.qnCountJson || {})?.map(([lang, json]) => (
                      <p className="tooltip-config-topic-error" key={lang}>
                        There are only {json.count} question
                        {json.count !== 1 ? "s" : ""} available in {LANGUAGES[json.lang].toLowerCase()}
                      </p>))
                  ))
                )
              }
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginLeft: "8px" }}
              >
                <path
                  d="M8 5.99997V8.66664M8 11.3333H8.00667M7.07688 2.59445L1.59362 12.0655C1.28948 12.5909 1.13742 12.8535 1.15989 13.0691C1.1795 13.2571 1.27801 13.428 1.43091 13.5392C1.60622 13.6666 1.90973 13.6666 2.51674 13.6666H13.4833C14.0903 13.6666 14.3938 13.6666 14.5691 13.5392C14.722 13.428 14.8205 13.2571 14.8401 13.0691C14.8626 12.8535 14.7105 12.5909 14.4064 12.0655L8.92312 2.59445C8.62007 2.07101 8.46855 1.80929 8.27087 1.72139C8.09843 1.64471 7.90157 1.64471 7.72913 1.72139C7.53145 1.80929 7.37992 2.07101 7.07688 2.59445Z"
                  stroke="#F79009"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Tooltip>
          ) : null}
        </p>
        {
          +type === libTypeIds.MCQ && (
            <InputDropdown
              label="Subjects"
              searchable
              value={topic.subject}
              // hintText={errors.topicId}
              // destructive={!!errors.topicId}
              options={subjects ?? []}
              onChange={(value) => onChange(topic.id, "subject", value)}
              placeholder="Enter Subject"
              // className="test-config-section-detail-config-topic-input"
              disabled={isPublished}
              className="test-config-section-detail-config-topic-title-dropdown"
            />
          )
        }
        <div className="test-config-section-detail-config-topic-input-fields">
          <InputDropdown
            label="Topic"
            searchable
            value={topic.topicId}
            hintText={errors.topicId}
            destructive={!!errors.topicId}
            options={topic?.topics ?? []}
            onChange={(value) => onChange(topic.id, "topicId", value)}
            placeholder="Enter Topic"
            className="test-config-section-detail-config-topic-input"
            disabled={isPublished}
          />
          {parseInt(type) === libTypeIds.DESCRIPTIVE && !isVideoAssessment && (
            <InputDropdown
              label="Type"
              placeholder="Select Type"
              options={descTypes}
              value={topic.configLibType}
              hintText={errors.configLibType}
              destructive={!!errors.configLibType}
              onChange={(value) => onChange(topic.id, "configLibType", value)}
              className="test-config-section-detail-config-topic-type-input"
              disabled={isPublished}
            />
          )}
          <InputDropdown
            label="Difficulty"
            value={topic.complexityId}
            options={difficulties}
            hintText={errors.complexityId}
            destructive={!!errors.complexityId}
            onChange={(value) => onChange(topic.id, "complexityId", value)}
            placeholder="Select Difficulty"
            className="test-config-section-detail-config-topic-difficulty-input"
            disabled={isPublished}
          />
          {parseInt(type) === libTypeIds.CODING_CHALLENGE && (
            <InputDropdown
              label="Allowed Languages"
              value={topic.languages ?? []}
              options={languages}
              multiple
              hintText={errors.languages}
              destructive={!!errors.languages}
              onChange={(value) => onChange(topic.id, "languages", value)}
              placeholder="Select Languages"
              className="test-config-section-detail-config-topic-languages-input"
              disabled={isPublished}
            />
          )}
          <div
            className={`test-config-section-detail-config-topic-chevron-icon${hasErrors ? " config-topic-error" : ""
              }`}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="#667085"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <InputField
            label="No. of Available Questions"
            placeholder=""
            type="number"
            name="availableQnCount"
            value={topic.availableQnCount}
            disabled={true}
            className="test-config-section-detail-config-topic-qns-count config-topic-qns-count"
          />
        </div>
      </div>
      <div className="test-config-section-detail-config-questions-score">
        <div className="test-config-section-detail-config-questions-container config-questions-score-container">
          <div className="test-config-section-detail-config-questions-title-container  config-title-container">
            <p className="test-config-section-detail-config-questions-title config-title">
              Configure Questions{" "}
              {errors?.qnsCount ? (
                <Tooltip title={errors.qnsCount}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginLeft: "8px" }}
                  >
                    <path
                      d="M8 5.99997V8.66664M8 11.3333H8.00667M7.07688 2.59445L1.59362 12.0655C1.28948 12.5909 1.13742 12.8535 1.15989 13.0691C1.1795 13.2571 1.27801 13.428 1.43091 13.5392C1.60622 13.6666 1.90973 13.6666 2.51674 13.6666H13.4833C14.0903 13.6666 14.3938 13.6666 14.5691 13.5392C14.722 13.428 14.8205 13.2571 14.8401 13.0691C14.8626 12.8535 14.7105 12.5909 14.4064 12.0655L8.92312 2.59445C8.62007 2.07101 8.46855 1.80929 8.27087 1.72139C8.09843 1.64471 7.90157 1.64471 7.72913 1.72139C7.53145 1.80929 7.37992 2.07101 7.07688 2.59445Z"
                      stroke="#F79009"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Tooltip>
              ) : null}
            </p>
            <Tooltip
              className="test-config-section-detail-config-questions-info-tooltip"
              title={
                <ul className="test-config-section-detail-config-questions-info">
                  <li>
                    <span>Random Questions:</span> Automatically selected based
                    on topic and difficulty
                  </li>
                  <li>
                    <span>Fixed Questions:</span> Manually chosen questions that
                    will always appear in the test
                  </li>
                </ul>
              }
            >
              <svg
                width="20"
                height="24"
                viewBox="0 0 20 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2175_5128)">
                  <path
                    d="M10.0001 15.3333V12M10.0001 8.66663H10.0084M18.3334 12C18.3334 16.6023 14.6025 20.3333 10.0001 20.3333C5.39771 20.3333 1.66675 16.6023 1.66675 12C1.66675 7.39759 5.39771 3.66663 10.0001 3.66663C14.6025 3.66663 18.3334 7.39759 18.3334 12Z"
                    stroke="#667085"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2175_5128">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(0 2)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </Tooltip>
          </div>
          <div className="test-config-section-detail-config-questions-count-container config-qns-score-count-container">
            <div className="test-config-section-detail-config-questions-count config-qns-score-count">
              <p className="test-config-section-detail-config-questions-count-title config-qns-score-count-title">
                {"No. of Random Questions"}
              </p>
              <QnCountField
                id={topic.id}
                name="randomQnCount"
                className="test-config-section-detail-config-qns-count-input-field"
                value={topic.randomQnCount}
                onChange={(event) =>
                  onChange(topic.id, event.target.name, event.target.value)
                }
                onClick={(value) => onChange(topic.id, "randomQnCount", value)}
                destructive={!!errors.randomQnCount || !!errors?.qnsCount}
                disabled={isPublished}
              />
              <p className="config-qns-count-mark-hint-text">
                {errors.randomQnCount}
              </p>
            </div>
            <hr />
            <div className="test-config-section-detail-config-fixedqn-container">
              <div className="test-config-section-detail-config-questions-count config-qns-score-count">
                <p className="test-config-section-detail-config-questions-count-title config-qns-score-count-title">
                  {"No. of Fixed Questions"}
                </p>
                <QnCountField
                  id={topic.id}
                  name="fixedQnCount"
                  className="test-config-section-detail-config-qns-count-input-field"
                  value={topic.fixedQnCount}
                  onChange={(event) =>
                    onChange(topic.id, event.target.name, event.target.value)
                  }
                  destructive={
                    !!(errors.fixedQnCount && topic.fixedQnCount) ||
                    !!errors?.qnsCount
                  }
                  onClick={(value) => onChange(topic.id, "fixedQnCount", value)}
                  disabled={isPublished}
                />
                {topic.fixedQnCount && errors.fixedQnCount ? (
                  <p className="config-qns-count-mark-hint-text">
                    {errors.fixedQnCount}
                  </p>
                ) : null}
              </div>
              <Button
                size="sm"
                hierarchy={{
                  type: "tertiaryGrey",
                  buttonText: "Configure",
                }}
                disable={+topic.fixedQnCount < 1}
                className="config-qns-count-configure-btn"
                icon={{
                  icon: (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.5 15L12.5 10L7.5 5"
                        stroke="#667085"
                        strokeWidth="1.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ),
                  type: "trailing",
                }}
                onClick={onConfigure}
              />
            </div>
          </div>
        </div>
        <div className="test-config-section-detail-config-score-container config-questions-score-container">
          <p className="test-config-section-detail-config-score-title config-title">
            Configure Score
          </p>
          <div className="test-config-section-detail-config-score-field-container config-qns-score-count-container config-qns-score-count">
            <p className="test-config-section-detail-config-score-field-title config-qns-score-count-title">
              Marks for Individual Question
            </p>
            <QnCountField
              id={topic.id}
              name="marks"
              className="test-config-section-detail-config-score-input-field"
              value={topic.marks}
              destructive={!!errors.marks}
              onChange={(event) =>
                onChange(topic.id, event.target.name, event.target.value)
              }
              onClick={(value) => onChange(topic.id, "marks", value)}
              disabled={isPublished}
            />
            {errors.marks ? (
              <p className="config-qns-count-mark-hint-text">{errors.marks}</p>
            ) : null}
          </div>
        </div>
      </div>
      {parseInt(type) === libTypeIds.CODING_CHALLENGE ||
        (parseInt(type) === libTypeIds.DESCRIPTIVE && isVideoAssessment) ? (
        <div className="test-config-section-detail-config-duration">
          <p className="test-config-section-detail-config-duration-title">
            Duration for Individual Question
          </p>
          <div className="test-config-section-detail-config-duration-input-fields">
            <div>
              <QnCountField
                id={topic.id}
                name="duration"
                className="test-config-section-detail-config-duration-input-field"
                value={topic.duration}
                onChange={(event) =>
                  onChange(topic.id, event.target.name, event.target.value)
                }
                onClick={(value) => onChange(topic.id, "duration", value)}
                destructive={!!errors.duration}
                disabled={isPublished}
              />
              {errors.duration ? (
                <p className="config-qns-count-mark-hint-text">
                  {errors.duration}
                </p>
              ) : null}
            </div>
            <InputDropdown
              placeholder="Min/Sec/Hrs"
              name="durationUnit"
              value={topic.durationUnit ?? "m"}
              className={`test-form-config-duration-type${errors?.duration ? " test-form-config-duration-field-error" : ""
                }`}
              onChange={(value) => onChange(topic.id, "durationUnit", value)}
              options={[
                {
                  label: "min/s",
                  value: "m",
                },
                // {
                //   label: "day/s",
                //   value: "d",
                // },
                {
                  label: "hour/s",
                  value: "h",
                },
              ]}
              hintText={errors?.durationUnit}
              destructive={!!errors?.durationUnit}
              disabled={isPublished}
            />
          </div>
        </div>
      ) : null}
      <div
        className={`test-config-section-detail-topic-delete-btn-container topic-delete-btn-container${parseInt(type) === libTypeIds.CODING_CHALLENGE
          ? " cc-topic-delete-btn-container"
          : ""
          }`}
      >
        <Button
          size="sm"
          destructive={true}
          hierarchy={{
            type: "tertiaryGrey",
            buttonText: "Delete Topic",
          }}
          disable={isPublished}
          onClick={() => setOpenPopup(true)}
          icon={{
            icon: (
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.5 4.99996H4.16667M4.16667 4.99996H17.5M4.16667 4.99996V16.6666C4.16667 17.1087 4.34226 17.5326 4.65482 17.8451C4.96738 18.1577 5.39131 18.3333 5.83333 18.3333H14.1667C14.6087 18.3333 15.0326 18.1577 15.3452 17.8451C15.6577 17.5326 15.8333 17.1087 15.8333 16.6666V4.99996H4.16667ZM6.66667 4.99996V3.33329C6.66667 2.89127 6.84226 2.46734 7.15482 2.15478C7.46738 1.84222 7.89131 1.66663 8.33333 1.66663H11.6667C12.1087 1.66663 12.5326 1.84222 12.8452 2.15478C13.1577 2.46734 13.3333 2.89127 13.3333 3.33329V4.99996M8.33333 9.16663V14.1666M11.6667 9.16663V14.1666"
                  stroke="#B42318"
                  strokeWidth="1.67"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ),
            type: "leading",
          }}
        />
      </div>
      <hr />
      <Modal
        className="text-config-question-list-modal"
        onClose={() => setShowQuestionList(false)}
        isOpen={showQuestionList}
        showCloseIcon={false}
      >
        <QuestionList
          setShowQuestionList={setShowQuestionList}
          type={topic.configLibType ?? type}
          topicId={topic.topicId}
          complexityId={topic.complexityId}
          languages={topic.languages}
          onSave={(value) => onChange(topic.id, "fixedQnIds", value)}
          neededCount={Number(topic.fixedQnCount)}
          fixedQnIds={topic.fixedQnIds}
          isPublished={isPublished}
        />
      </Modal>
      <Modal
        isOpen={openPopup}
        closeIcon={null}
        showCloseIcon={false}
        onClose={() => setOpenPopup(false)}
        className="config-topic-confirmation-modal"
      >
        <ModalBody
          content={
            <>
              <p className="config-topic-confirmation-modal-title">
                Delete Topic
              </p>
              <p className="config-topic-confirmation-modal-content">
                Are you sure you want to delete the topic?
              </p>
            </>
          }
          footer={
            <div className="config-topic-confirmation-footer">
              <Button
                size="sm"
                hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
                onClick={() => setOpenPopup(false)}
              />
              <Button
                size="sm"
                hierarchy={{ type: "primary", buttonText: "Delete" }}
                destructive={true}
                onClick={() => onDelete(topic)}
              />
            </div>
          }
        />
      </Modal>
    </div>
  );
};

export default ConfigureTopic;

// export const QnCountField = ({
//   className = "",
//   id,
//   value,
//   name,
//   onChange,
//   onClick,
//   placeholder = "00",
//   hintText = "",
//   destructive = false,
//   disabled = false,
// }) => {
//   return (
//     <div
//       className={`config-qns-score-count-field${
//         hintText ? " qns-score-count-hint-text" : ""
//       } ${className}`}
//       key={id}
//     >
//       <IconButton
//         hierarchy="secondaryGrey"
//         onClick={() => onClick(parseInt(value || 0) - 1)}
//         disabled={!value || +value === 0 || disabled}
//       >
//         <svg
//           width="14"
//           height="14"
//           viewBox="0 0 14 14"
//           fill="none"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <path
//             d="M2.91675 7H11.0834"
//             stroke="#344054"
//             strokeWidth="1.169"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           />
//         </svg>
//       </IconButton>
//       <InputField
//         placeholder={placeholder}
//         className="config-qns-count-input"
//         name={name}
//         type="number"
//         destructive={destructive}
//         value={value}
//         onChange={onChange}
//         disabled={disabled}
//       />
//       <IconButton
//         hierarchy="secondaryGrey"
//         onClick={() => onClick(parseInt(value || 0) + 1)}
//         disabled={disabled}
//       >
//         <svg
//           width="14"
//           height="14"
//           viewBox="0 0 14 14"
//           fill="none"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <path
//             d="M7.00008 2.91663V11.0833M2.91675 6.99996H11.0834"
//             stroke="#344054"
//             strokeWidth="1.169"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           />
//         </svg>
//       </IconButton>
//     </div>
//   );
// };
